import Base from "../../../base";
import Form from "../../../layout/form";
import CompanyListLayout from "../../layout";
import CompanyUserService from "../../../../services/company/user";
import BankListLayout from "../../../running/bank/layout";
import BankService from "../../../../services/running/bank";
import CompanyService from "../../../../services/company";

export default class CompanyUserEdit extends Base
{
    boot() {
        this.state = {
            model:{
                companyId:0,
                username:'',
                portrait:'',
                realname:'',
                phone:'',
                password:'',
                status:1,
                locateMode:1,
                bankAccount:'',
                bankName:'',
                bankId:0
            },
            company:[],
            bank:[]
        }
        /* global layer */
    }

    service() {
        return CompanyUserService;
    }

    componentDidMount() {
        this.server.getDetail(this.getPropsParams('id'), data => {
            this.setModel(data);

            this.server.getService(CompanyService).getDetail(data.companyId, company => {
                this.setState({
                    company:[company]
                })
            })

            if (data.bankId) {
                this.server.getService(BankService).getDetail(data.bankId, bank => {
                    this.setState({
                        bank:[bank]
                    })
                })
            }
        })
    }

    render() {
        return (
            <Form
                state={this.state}
                fields={{
                    portrait: {name:'头像', type:'image'},
                    company:{name:'公司', type:'choose', component: this.company.bind(this), click: this.chooseCompany.bind(this)},
                    username:'员工账号',
                    password:{name:'密码', type: 'password'},
                    realname:'姓名',
                    phone:'手机号码',
                    locateMode:{name:'定位方式', type:'select', data: this.server.locateMode},
                    bank:{name:'银行', type:'choose', component: this.bank.bind(this), click: this.chooseBank.bind(this)},
                    bankAccount:'银行账号',
                    status:{name:'状态', type:'select', data: this.server.status}
                }}
            />
        );
    }

    company(state) {
        return (
            <CompanyListLayout
                autoload={false}
                show={state.company.length}
                list={state.company}
                paging={false}
                searchShow={false}
                btnShow={false}
                oprationShow={false}
                layuiFluid={false}
                layuiCardBody={false}
                inputName={'companyId'}
            />
        )
    }

    chooseCompany(form) {
        this.layOpen({
            title:'选择公司',
            content:'/admin/company/choose/list',
            form: true,
            yes: (fields, index) => {
                fields = this.app.htmlArrayToJson(fields);
                let data = fields.data;
                if (! data || ! data.length) {
                    return layer.msg('请选择公司');
                }
                form.setState({
                    company:[JSON.parse(data[0])]
                })
                layer.close(index);
            }
        })
    }

    bank(state) {
        return (
            <BankListLayout
                autoload={false}
                show={state.bank.length}
                list={state.bank}
                paging={false}
                searchShow={false}
                btnShow={false}
                oprationShow={false}
                layuiFluid={false}
                layuiCardBody={false}
                visibles={['id', 'name', 'typeDup']}
                inputName={'bankId'}
            />
        )
    }

    chooseBank(form) {
        this.layOpen({
            title:'选择银行',
            content:'/admin/running/bank/choose/list',
            form: true,
            yes: (fields, index) => {
                fields = this.app.htmlArrayToJson(fields);
                let data = fields.data;
                if (! data || ! data.length) {
                    return layer.msg('请选择银行');
                }
                form.setState({
                    bank:[JSON.parse(data[0])]
                })
                layer.close(index);
            }
        })
    }
}

